// extracted by mini-css-extract-plugin
module.exports = {"icon":"r8KvAoyghE"};
    if(module.hot) {
      // 1597843269491
      var cssReload = require("!../../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  